module.exports = __webpack_public_path__ + "modules/home/images/saas_3.png?062636f8";


//////////////////
// WEBPACK FOOTER
// ./modules/home/images/saas_3.png
// module id = 78
// module chunks = 0